var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulkManage = function SvgBulkManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulk_manage_svg2__a",
    x1: 28,
    x2: 193.1,
    y1: 97.9,
    y2: -7.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage_svg2__a",
    id: "bulk_manage_svg2__b",
    x1: -3.9,
    x2: 28.1,
    y1: 54.3,
    y2: 33.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage_svg2__a",
    id: "bulk_manage_svg2__c",
    x1: -3.6,
    x2: 28.1,
    y1: 110.5,
    y2: 90.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage_svg2__a",
    id: "bulk_manage_svg2__d",
    x1: -3.6,
    x2: 28.1,
    y1: 166.7,
    y2: 146.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage_svg2__a",
    id: "bulk_manage_svg2__e",
    x1: 27.4,
    x2: 205.9,
    y1: 158.6,
    y2: 44.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage_svg2__a",
    id: "bulk_manage_svg2__f",
    x1: 30,
    x2: 148.5,
    y1: 195.1,
    y2: 119.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M50.1 56.2h125c6.9 0 12.5-5.6 12.5-12.5s-5.6-12.5-12.5-12.5h-125c-6.9 0-12.5 5.6-12.5 12.5s5.6 12.5 12.5 12.5",
    style: {
      fill: "url(#bulk_manage_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8 34.9C1.4 37.3 0 40.4 0 43.7v2.4c.1.8.4 1.6.7 2.4.3.7.7 1.5 1.2 2.1.4.7 1 1.4 1.6 1.9.6.6 1.2 1.1 1.9 1.5q1.05.75 2.1 1.2c.8.4 1.7.7 2.6.9h2.4c3.3 0 6.5-1.3 8.8-3.6.6-.6 1.1-1.2 1.6-1.9q.75-1.05 1.2-2.1.6-1.2.9-2.4v-2.4c0-3.3-1.3-6.5-3.7-8.8-4.9-4.8-12.7-4.8-17.6 0Z",
    style: {
      strokeWidth: 0,
      fill: "url(#bulk_manage_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9 93c-.4-.7-1-1.3-1.6-1.9-4.9-4.8-12.7-4.8-17.6 0C1.4 93.4 0 96.6 0 99.9c0 1.6.3 3.3.9 4.8.3.7.7 1.4 1.1 2.1.5.7 1 1.3 1.6 1.9s1.2 1.1 1.9 1.6q1.05.75 2.1 1.2c.8.3 1.6.6 2.4.7.8.2 1.6.3 2.4.2h2.4c.8-.1 1.6-.4 2.3-.7.8-.3 1.5-.7 2.2-1.2.7-.4 1.3-1 1.9-1.6s1.1-1.2 1.6-1.9q.75-1.05 1.2-2.1c.4-.8.7-1.7.9-2.6v-4.8c-.2-.8-.5-1.6-.9-2.3-.3-.8-.7-1.5-1.2-2.2Z",
    style: {
      strokeWidth: 0,
      fill: "url(#bulk_manage_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9 149.3c-.4-.7-1-1.3-1.6-1.9-4.9-4.8-12.7-4.8-17.6 0-.6.6-1.1 1.2-1.6 1.9q-.75 1.05-1.2 2.1c-.3.8-.6 1.6-.7 2.4q-.3 1.2-.3 2.4c0 3.3 1.3 6.5 3.7 8.8.6.6 1.2 1.1 1.9 1.6q1.05.75 2.1 1.2c.8.3 1.6.6 2.4.7.8.2 1.6.3 2.4.2h2.4c.8-.1 1.6-.4 2.3-.7.8-.3 1.5-.7 2.2-1.2.7-.4 1.3-1 1.9-1.6s1.1-1.2 1.6-1.9q.75-1.05 1.2-2.1c.4-.8.7-1.7.9-2.6v-4.8q-.3-1.2-.9-2.4c-.3-.7-.7-1.5-1.2-2.1Z",
    style: {
      strokeWidth: 0,
      fill: "url(#bulk_manage_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5 87.5H50.1c-6.9 0-12.5 5.6-12.5 12.5s5.6 12.5 12.5 12.5h137.5c6.9 0 12.5-5.6 12.5-12.5s-5.6-12.5-12.5-12.5Z",
    style: {
      strokeWidth: 0,
      fill: "url(#bulk_manage_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3 143.7H50.1c-6.9 0-12.5 5.6-12.5 12.5s5.6 12.5 12.5 12.5h81.2c6.9 0 12.5-5.6 12.5-12.5s-5.6-12.5-12.5-12.5",
    style: {
      strokeWidth: 0,
      fill: "url(#bulk_manage_svg2__f)"
    }
  }));
};
export default SvgBulkManage;